import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { CloseBtn } from '../../theme/common_style';

const Container = styled.div`
  width: 100%;
  min-width: 290px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  border: 2px solid ${(props) => (props.status ? '#2ecc71' : '#e74c3c')};
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`;

const Header = styled.div`
  background: ${(props) =>
    props.status
      ? 'linear-gradient(135deg, #2ecc71, #27ae60)' // green gradient
      : 'linear-gradient(135deg, #e74c3c, #c0392b)'}; // red gradient
  color: #fff;
  padding: 5px 8px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);

  .project-name {
    font-size: 16px;
    font-weight: 600;
    position: relative;
    text-transform: capitalize;
    cursor: pointer;
  }
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 8px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }

  span:first-child {
    font-weight: 500;
    color: #777;
  }

  span:last-child {
    font-weight: 600;
    color: #333;
  }
`;

const StatusBadge = styled.span`
  width: 80px;
  background: ${(props) => (props.status ? '#d0f3dfff' : '#facdc8ff')};
  color: ${(props) => (props.status ? '#27ae60' : '#e74c3c')};
  font-size: 13px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 10px;
  text-align: center;
`;

function ProjectCard({ item }) {
  if (!item) return null;

  return (
    <Container status={item?.is_working}>
      <Header status={item?.is_working}>
        Project <span className="project-name">{item?.project_name || 'Not Available'}</span>
      </Header>

      <InfoRow>
        <span>Status:</span>
        <StatusBadge status={item?.is_working}>{item?.is_working ? 'Busy' : 'Free'}</StatusBadge>
      </InfoRow>

      <InfoRow>
        <span>Start Date:</span>
        <span>{item?.start_date}</span>
      </InfoRow>

      <InfoRow>
        <span>End Date:</span>
        <span>{item?.end_date}</span>
      </InfoRow>

      <InfoRow>
        <span>Days:</span>
        <span>{item?.days}</span>
      </InfoRow>
    </Container>
  );
}

const DetailsDayModal = ({ isOpen, onClose, project }) => {
  if (!project) return null;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      centered
      width={project?.length > 1 ? 700 : 360}
      footer={null}
      closeIcon={false}
      destroyOnClose={true}
      prefixCls="create-employees">
      <CloseBtn onClick={onClose}>x</CloseBtn>
      <WrapperContainer>
        <Heading>Projects Billing Days</Heading>
        <Hline />
        <ContainerBox projectLength={project?.length > 6}>
          {project?.map((item) => {
            return <ProjectCard item={item} key={item.project_id} />;
          })}
        </ContainerBox>
      </WrapperContainer>
    </Modal>
  );
};

export default DetailsDayModal;

DetailsDayModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.boolean,
  project: PropTypes.array
};
ProjectCard.propTypes = {
  item: PropTypes.object
};

const WrapperContainer = styled.div`
  width: 100%;
  padding: 20px 10px;
`;
const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
`;
const ContainerBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  align-items: center;
  padding: 20px;

  gap: 20px;
  height: 'fit-content';
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;
const Hline = styled.hr`
  border: none;
  height: 1px;
  width: 100%;
  background: #e0e0e0;
  margin-top: 8px;
  margin-bottom: 3px;
`;
